export default __webpack_public_path__ + "static/img-9-15939a1434c81756fd2d58861955f2cb.png";